import { ApiRepository } from './base_repository';
import { sharedAxiosInstance } from '../../utils/axios/axios';
import OpenAI from 'openai';
import { toast } from 'react-toastify';
import { PerplexityResponse } from '../../data/types/utilities';
import similarity from 'string-comparison';

class UtilitiesApiRepository extends ApiRepository {
  private static instance: UtilitiesApiRepository | null = null;
  constructor(axiosInstance: any) {
    super(axiosInstance);
  }

  public static getInstance(axiosInstance: any): UtilitiesApiRepository {
    if (!UtilitiesApiRepository.instance) {
      UtilitiesApiRepository.instance = new UtilitiesApiRepository(
        axiosInstance,
      );
    }
    return UtilitiesApiRepository.instance;
  }

  translateText = async (
    text: string,
    translatingArabicToEnglish: boolean = false,
  ) => {
    // const res = await fetch(
    //   `https://translation.googleapis.com/language/translate/v2?key=AIzaSyAAVVck4wb4sGAmMsfEBCsfVH5ofSzkJqE`,
    //   {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       q: [text],
    //       source: translatingArabicToEnglish ? 'ar' : 'en',
    //       target: translatingArabicToEnglish ? 'en' : 'ar',
    //       format: 'text',
    //     }),
    //   },
    // );
    // const result = await res.json();
    // const translatedHTML = result.data.translations[0].translatedText;
    // return translatedHTML;
    return this.translateTextWithOpenAI(text, translatingArabicToEnglish);
  };

  translateHTML = async (
    htmlContent: string,
    translatingArabicToEnglish = false,
  ) => {
    // const res = await fetch(
    //   `https://translation.googleapis.com/language/translate/v2?key=AIzaSyAAVVck4wb4sGAmMsfEBCsfVH5ofSzkJqE`,
    //   {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify({
    //       q: [htmlContent],
    //       source: translatingArabicToEnglish ? 'ar' : 'en',
    //       target: translatingArabicToEnglish ? 'en' : 'ar',
    //       format: 'html',
    //     }),
    //   },
    // );
    // const result = await res.json();
    // const translatedHTML = result.data.translations[0].translatedText;
    // return translatedHTML;
    return this.translateHTMLWithOpenAI(
      htmlContent,
      translatingArabicToEnglish,
    );
  };

  translateTextWithOpenAI = async (
    text: string,
    translatingArabicToEnglish = false,
  ) => {
    const prompt = `Professionally translate the following text from ${translatingArabicToEnglish ? 'Arabic' : 'English'} to ${translatingArabicToEnglish ? 'English' : 'Arabic'}. Text must be accurate and clear and professional for a top-notch e-commerce website, DON'T ADD PUNCTIONATS unless original text had it".

Text:
${text}`;

    const openai = new OpenAI({
      apiKey: (import.meta as any).env.VITE_OPENAI_API_KEY,
      dangerouslyAllowBrowser: true,
    });
    const response = await openai.chat.completions.create({
      model: 'gpt-4o',
      messages: [{ role: 'user', content: prompt }],
      temperature: 1,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0,
      response_format: {
        type: 'json_schema',
        json_schema: {
          name: 'translation',
          strict: true,
          schema: {
            type: 'object',
            properties: {
              translatedText: {
                type: 'string',
                description:
                  'The translated text result from Arabic to English or English to Arabic.',
              },
            },
            required: ['translatedText'],
            additionalProperties: false,
          },
        },
      },
    });
    // Extract the translated text from the response
    const preJson = response.choices[0].message.content as string;
    const json = JSON.parse(preJson);
    return json.translatedText as string;
  };

  translateHTMLWithOpenAI = async (
    htmlContent: string,
    translatingArabicToEnglish = false,
  ) => {
    const prompt = `Translate the following HTML content from ${
      translatingArabicToEnglish ? 'Arabic' : 'English'
    } to ${translatingArabicToEnglish ? 'English' : 'Arabic'}.
Maintain the HTML structure and ensure the translation is professional, accurate, and suitable for a top-notch e-commerce website.
HTML Content:
${htmlContent}`;

    const openai = new OpenAI({
      apiKey: (import.meta as any).env.VITE_OPENAI_API_KEY,
      dangerouslyAllowBrowser: true,
    });

    const response = await openai.chat.completions.create({
      model: 'gpt-4o-mini',
      messages: [{ role: 'user', content: prompt }],
      temperature: 1.0,
      top_p: 1.0,
      frequency_penalty: 0,
      presence_penalty: 0,
      response_format: {
        type: 'json_schema',
        json_schema: {
          name: 'translation',
          strict: true,
          schema: {
            type: 'object',
            properties: {
              translatedHTML: {
                type: 'string',
                description: 'The translated HTML content.',
              },
            },
            required: ['translatedHTML'],
            additionalProperties: false,
          },
        },
      },
    });

    // Parse the structured response to extract the translated HTML
    const preJson = response.choices[0].message.content as string;
    const json = JSON.parse(preJson);
    return json.translatedHTML;
  };

  rewriteNamesWithOpenAI = async (
    name_en: string,
    name_ar: string,
    context: string,
  ) => {
    const prompt = `Generate a professional and accurate product name in both English and Arabic for an ecommerce app. Each product name should be clear, concise, and appropriate for an online retail context. Make sure to capture the essential features and category of the product, using language that appeals to a broad customer base and follows ecommerce naming standards. The English name should be modern and straightforward, while the Arabic name should maintain the same tone but adapt naturally to Arabic language conventions.
    For example, if the product is a "The Quarry: A Spine-Chilling Interactive Horror Experience - PS5" and "لعبة The Quarry المحجر: تجربة رعب تفاعلية مثيرة", the suggested names could be "The Quarry for Playstation 5" in English and "لعبة ذا كواري للبلايستيشن 5" or "لعبة The Quarry لجهاز Playstation 5" in Arabic.
Name in English:
${name_en}
Name in Arabic:
${name_ar}
    Context:
    ${context}`;

    const openai = new OpenAI({
      apiKey: (import.meta as any).env.VITE_OPENAI_API_KEY,
      dangerouslyAllowBrowser: true,
    });

    const response = await openai.chat.completions.create({
      model: 'gpt-4o',
      messages: [{ role: 'user', content: prompt }],
      temperature: 1.0,
      max_tokens: 128, // You might need to adjust based on expected translation length
      top_p: 1.0,
      frequency_penalty: 0,
      presence_penalty: 0,
      response_format: {
        type: 'json_schema',
        json_schema: {
          name: 'translation',
          strict: true,
          schema: {
            type: 'object',
            properties: {
              suggested_name_en: {
                type: 'string',
                description: 'The suggested names in English.',
              },
              suggested_name_ar: {
                type: 'string',
                description: 'The suggested names in Arabiv.',
              },
            },
            required: ['suggested_name_en', 'suggested_name_ar'],
            additionalProperties: false,
          },
        },
      },
    });

    // Parse the structured response to extract the translated HTML
    const preJson = response.choices[0].message.content as string;
    const json = JSON.parse(preJson);
    return {
      suggested_name_en: json.suggested_name_en,
      suggested_name_ar: json.suggested_name_ar,
    };
  };

  writeListingWhatsInTheBox = async (
    name_en: string,
    name_ar: string,
    description_en: string,
    description_ar: string,
  ) => {
    const prompt = `Generate a list of items that come in the box for the following product. The list should be comprehensive, accurate, and suitable for an ecommerce app. Include only items that are typically included with the product, such as accessories, manuals (if any), and other relevant items. Use your information with caution on which items to include. The list should be clear, concise, and easy to read, with each item separated by a comma. The list should be in both English and Arabic, with the Arabic list following the same order and format as the English list.
Name in English:
${name_en}
Name in Arabic:
${name_ar}
Description in English:
${description_en}
Description in Arabic:
${description_ar}`;

    const openai = new OpenAI({
      apiKey: (import.meta as any).env.VITE_OPENAI_API_KEY,
      dangerouslyAllowBrowser: true,
    });

    const response = await openai.chat.completions.create({
      model: 'gpt-4o',
      messages: [{ role: 'user', content: prompt }],
      temperature: 1.0,
      top_p: 1.0,
      frequency_penalty: 0,
      presence_penalty: 0,
      response_format: {
        type: 'json_schema',
        json_schema: {
          name: 'translation',
          strict: true,
          schema: {
            type: 'object',
            properties: {
              whats_included: {
                type: 'string',
                description: 'The list of items that come in the box.',
              },
            },
            required: ['whats_included'],
            additionalProperties: false,
          },
        },
      },
    });

    // Parse the structured response to extract the translated HTML
    const preJson = response.choices[0].message.content as string;
    const json = JSON.parse(preJson);
    return json.whats_included;
  };

  getCategoryDescription = async (
    categoryNameEn: string,
    categoryNameAr: string,
    categoryParentsEn: string[],
    categoryParentsAr: string[],
    categoryEnChildren: string[],
    categoryArChildren: string[],
  ) => {
    const openai = new OpenAI({
      apiKey: (import.meta as any).env.VITE_OPENAI_API_KEY,
      dangerouslyAllowBrowser: true,
    });

    const prompt = `
    Generate a comprehensive, informative and best-in-class description for the following category. You can use same level categories to know more about the category. The description should be in English and Arabic, and should be relevant and descriptive. Don't include the word "DESCRIPTION" in the description. Both languages are very important (Arabic is more important).
    Category Name in English: ${categoryNameEn}
    Category Name in Arabic: ${categoryNameAr}
    Category Path in English: ${categoryParentsEn.join(' > ') + ' > ' + categoryNameEn}
    Category Path in Arabic: ${categoryParentsAr.join(' > ') + ' > ' + categoryNameAr}
    Category same level categories in English are: ${categoryEnChildren.join(', ')}
    Category same level categories in Arabic are: ${categoryArChildren.join(', ')}
    Limit the outpt to 100 completion_tokens or less characters.
    Format the description as a single paragraph, separate languages with ----, and don't include the word "DESCRIPTION" in the description.
  `;

    const response = await openai.chat.completions.create({
      model: 'gpt-4o',
      messages: [{ role: 'user', content: prompt }],
      temperature: 1,
      max_tokens: 256,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0,
    });

    return response.choices[0].message.content;
  };

  getCategoryKeywords = async (
    categoryNameEn: string,
    categoryNameAr: string,
    categoryParentsEn: string[],
    categoryParentsAr: string[],
    categoryEnChildren: string[],
    categoryArChildren: string[],
    parentKeywords: string,
  ) => {
    const openai = new OpenAI({
      apiKey: (import.meta as any).env.VITE_OPENAI_API_KEY,
      dangerouslyAllowBrowser: true,
    });

    const prompt = `
    Generate a list of keywords for the following category, the keywords should be relevant and descriptive, SEO Professional, you may include synonyms and related terms, you may use slang language if it is relevant. You can use same level categories to know more about the category. Both languages are very important (Arabic is more important). For example, for the category "Mobile Phones", results should be: smartphone, cell phone, mobile, iPhone, Samsung, Android, iOS, 5G, calling, texting, internet, camera, apps, games, social media, mobile accessories, mobile repair, هواتف ذكية, جوال, تليفون, ايفون, سامسونج, تطبيقات, العاب, وسائل التواصل الاجتماعي, اكسسوارات الجوال, صيانة الجوال
    Take into consideration the parent category keywords: ${parentKeywords}, and do not repeat them.
    Category Name in English: ${categoryNameEn}
    Category Name in Arabic: ${categoryNameAr}
    Category Path in English: ${categoryParentsEn.join(' > ') + ' > ' + categoryNameEn}
    Category Path in Arabic: ${categoryParentsAr.join(' > ') + ' > ' + categoryNameAr}
    Category same level categories in English are: ${categoryEnChildren.join(', ')}
    Category same level categories in Arabic are: ${categoryArChildren.join(', ')}
    Limit the output to 15 completion_tokens or less characters. 
    DON'T REPEAT WORDS
    Output format:
    keyword, كلمة مفتاحية،, keyword, كلمة مفتاحية, keyword, ... .and don't include the word "KEYWORDS" in the keywords or numbers, and no need to write "English Keywords: or Arabic Keywords:".
  `;

    const response = await openai.chat.completions.create({
      model: 'gpt-4o',
      messages: [{ role: 'user', content: prompt }],
      temperature: 1,
      max_tokens: 256,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0,
    });

    return response.choices[0].message.content;
  };

  suggestAttributeValueForItem = async ({
    productNameEn,
    productManfacturerBarcode,
    requestedAttributeNameEn,
    attributeType,
    attributeUnit,
  }: {
    productNameEn: string;
    productManfacturerBarcode: string;
    requestedAttributeNameEn: string;
    attributeType: string;
    attributeUnit?: string;
  }) => {
    const prompt = `Be percise and concise. Suggest a value for the following attribute for the product "${productNameEn}" with the manufacturer barcode "${productManfacturerBarcode}". The attribute is "${requestedAttributeNameEn}" and is of type "${attributeType}", if numeric,  always return as float with 2 points, if boolean return as true/false.
    ${attributeUnit ? `The unit for this attribute is "${attributeUnit}", it can be float.` : ''}
    I need the exact value only, not the attribute name, not a range, not any other information.`;

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${(import.meta as any).env.VITE_PERPLEXITY_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'sonar',
        messages: [{ role: 'user', content: prompt }],
        max_tokens: 100,
        temperature: 0.2,
        top_p: 0.9,
        search_domain_filter: null,
        return_images: false,
        return_related_questions: false,
        search_recency_filter: 'month',
        top_k: 0,
        stream: false,
        presence_penalty: 0,
        frequency_penalty: 1,
        response_format: null,
      }),
    };

    const response = await fetch(
      'https://api.perplexity.ai/chat/completions',
      options,
    );
    return response
      .json()
      .then((res) => {
        return {
          prompt,
          answer: res.choices[0].message.content as string,
          citations: res.citations,
        } as PerplexityResponse;
      })
      .catch(() => {
        toast.error(
          `Failed to suggest attribute value for ${requestedAttributeNameEn}`,
        );
        return {
          prompt,
          answer: 'Error',
          citations: [],
        } as PerplexityResponse;
      });
  };

  checkItemNameAndBarcodeConsistency = async ({
    productNameEn,
    productManfacturerBarcode,
  }: {
    productNameEn: string;
    productManfacturerBarcode: string;
  }) => {
    const prompt = `Be percise and concise. Check the consistency between the product name "${productNameEn}" and the manufacturer barcode "${productManfacturerBarcode}". The product name MUST match the barcode.
    IF Yes, return "Yes", if No, return "No - 'Correct Product for Barcode': XXXX, 'Correct Barcode for Product': YYYY", where XXXX is the correct product name for the barcode and YYYY is the correct barcode for the product name.
    Each answer in new line.    
`;

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${(import.meta as any).env.VITE_PERPLEXITY_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: 'sonar',
        messages: [{ role: 'user', content: prompt }],
        max_tokens: 100,
        temperature: 0.2,
        top_p: 0.9,
        search_domain_filter: null,
        return_images: false,
        return_related_questions: false,
        search_recency_filter: 'month',
        top_k: 0,
        stream: false,
        presence_penalty: 0,
        frequency_penalty: 1,
        response_format: null,
      }),
    };

    const response = await fetch(
      'https://api.perplexity.ai/chat/completions',
      options,
    );
    return response
      .json()
      .then((res) => {
        return {
          prompt,
          answer: res.choices[0].message.content as string,
          citations: res.citations,
        } as PerplexityResponse;
      })
      .catch(() => {
        toast.error(`Failed to suggest.`);
        return {
          prompt,
          answer: 'Error',
          citations: [],
        } as PerplexityResponse;
      });
  };

  removeImageBg = async ({
    fileUrl,
    file,
  }: {
    fileUrl?: string;
    file?: File;
  }) => {
    if (!fileUrl && !file) {
      toast.warn('Please provide a file or a file URL');
      return;
    } else if (fileUrl && file) {
      toast.warn('Please provide either a file or a file URL, not both');
      return;
    }
    var res;
    toast.info('Removing background, please wait...');
    const url = 'https://sdk.photoroom.com/v1/segment';
    const form = new FormData();
    if (file) {
      form.append('image_file', file);
    } else if (fileUrl) {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      form.append('image_file', blob, 'image.png');
    }

    const options = {
      method: 'POST',
      headers: {
        Accept: 'image/png, application/json',
        'x-api-key': (import.meta as any).env.VITE_PHOTOROOM_API_KEY,
      },
      body: form,
    };

    res = await fetch(url, options);

    // Convert img/png to file and download
    if (res.status !== 200) {
      return false;
    }
    const blob = await res.blob();
    return blob;
  };

  // Utility to determine the color based on similarity score
  getSimilarityColor = (
    officialValue: string,
    suggestedValue: string,
  ): string => {
    // Preprocess: convert to lowercase and trim spaces
    const cleanOfficial = officialValue.toLowerCase().trim();
    const cleanSuggested = suggestedValue.toLowerCase().trim();

    // Calculate similarity score (assumed to be between 0 and 1)
    let cos = similarity.cosine;
    const score = cos.similarity(cleanOfficial, cleanSuggested);

    // Define thresholds for similarity
    if (score >= 0.9) return 'green'; // Very similar
    if (score >= 0.5) return 'orange'; // Moderately similar
    return 'red'; // Not similar
  };
}

const UtilitiesRepository =
  UtilitiesApiRepository.getInstance(sharedAxiosInstance);
export default UtilitiesRepository;
